import { useSelector } from "react-redux";

export const usePermission = () => {
  const permissionMap = useSelector((state) => state.permissions.permissionMap);

  // console.log("permissionMap", permissionMap);
  // console.log("permissionMap keys", Object.keys(permissionMap));
  // console.log("permissionMap values", Object.values(permissionMap));

  const hasPermission = (moduleKey, permission) => {
    const key = moduleKey?.toLowerCase();
    const mod = permissionMap[key];
    if (!mod) return false;
    return mod[permission] === 1;
  };

  const hasAny = (moduleKey, list = []) =>
    list.some((perm) => hasPermission(moduleKey, perm));
  
  return { hasPermission, hasAny };
};
